import { Heading, Icon, Paragraph, TextButton, Upsell } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';
import { shallowEqual } from 'react-redux';
import { US_STATES_LABEL_MAP } from '@zg-rentals/states-territories';

import { RoutingSelectors } from '../../../selectors';
import { useSelector } from '../../../selectors/useSelector';
import ManageTenantsCSEvents from '../../../model/ClickstreamEvent/ManageTenantsCSEvents';

type Props = {
  state?: string;
};

const GeneratedLeaseUpsell = ({ state: propertyState }: Props) => {
  const { currentProperty, user, propertyId } = useSelector(
    (reduxState) => ({
      currentProperty: reduxState.properties.currentProperty,
      user: reduxState.user,
      propertyId: RoutingSelectors.makeListingId(reduxState),
    }),
    shallowEqual,
  );

  const handleViewLeaseClick = () => {
    ManageTenantsCSEvents.ViewGeneratedLease({ currentProperty, user });

    const leaseGenerateUrl = `/rental-manager/leasing/property/${propertyId}/generate`;
    window.location.href = leaseGenerateUrl;
  };

  const stateName = propertyState
    ? US_STATES_LABEL_MAP[propertyState.toUpperCase() as keyof typeof US_STATES_LABEL_MAP] || propertyState
    : 'your state';

  return (
    <Upsell
      data-testid="GeneratedLeaseUpsell"
      tone="soft"
      closeable={false}
      media={
        <Icon>
          <IconChecklistFilled />
        </Icon>
      }
      header={<Heading level={1}>Need a lease agreement?</Heading>}
      body={
        <Paragraph>We’ve created a custom lease for you that includes legal clauses specific to {stateName}.</Paragraph>
      }
      action={
        <TextButton
          tone="brand"
          onClick={handleViewLeaseClick}
          data-eventid={ManageTenantsCSEvents.ViewGeneratedLease.data_event_id}
        >
          View lease
        </TextButton>
      }
      elevated={false}
    />
  );
};

export default GeneratedLeaseUpsell;
